import { EditDepartmentDto } from "../../../../../models/app/admin/department";
import { AddDepartmentFormValidationSchema } from "../AddDepartmentForm/AddDepartmentFormValues";

export type EditDepartmentFormValues = EditDepartmentDto;

export const EditDepartmentFormValidationSchema =
    AddDepartmentFormValidationSchema;
